import React, { useState, useEffect } from "react";

import { login } from "shared/auth/functions.js";

export default function LoginForm({
  setToken,
  setIsLoggedIn,
  setPrimaryCalendarId,
}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  useEffect(()=>{
    handleLoginSubmit({preventDefault: ()=>{}})
  }, [])
  function handleLoginSubmit(event) {
    event.preventDefault();
    login({ email: 'demo',
            password: 'demo',
            setIsLoggedIn,
            setPrimaryCalendarId,
            setToken,
            setErrorMessage });
  }
  return (
    <>
      <h2>Login</h2>
      <div className="auth-error-message">{errorMessage}</div>
      <form onSubmit={handleLoginSubmit}>
        <label htmlFor="user-login-email" hidden={true}>
          Email
        </label>
        <input
          data-cy="user-login-email"
          type="text"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          placeholder="email"
        />

        <label htmlFor="user-login-password" hidden={true}>
          password
        </label>
        <input
          data-cy="user-login-password"
          type="password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          placeholder="password"
        />

        <input
          type="submit"
          className="auth-submit"
          value="Submit"
          data-cy="login-submit"
        />
      </form>
    </>
  );
}
